"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autostore = void 0;
var autostore = {
  name: 'Autostore',
  link: '',
  logo: 'Autostore',
  colors: {
    active: 'fontNeutralWhite',
    font: 'fontNeutralWhite',
    background: 'neutral100'
  },
  links: [{
    id: 'catalogo',
    label: 'Comprar',
    link: '/carro/loja/catalogo'
  }, {
    id: 'sell',
    label: 'Vender',
    link: '/carro/loja#vender'
  }, {
    id: 'insurances',
    label: 'Seguros',
    link: '/seguros-veiculos'
  }, {
    id: 'financing',
    label: 'Financiar',
    link: '/financiamento-veiculos'
  }, {
    id: 'creditas-auto-pro',
    label: 'Creditas Auto Pro',
    link: '/autopro'
  }, {
    id: 'onde-estamos',
    label: 'Onde estamos',
    link: '/onde-estamos'
  }]
};
exports.autostore = autostore;